import { trackEvent } from "@features/tracking/tracking"
import { SliderTimer } from "@hooks/useSliderTimer"
import { tv } from "@utils/tw"
import { useState } from "react"

type Props = {
  timer: SliderTimer
}

export function SlideTimerIndicator(props: Props) {
  const [hovering, setHovering] = useState(false)
  const styles = createStyles({
    hovering,
  })

  if (props.timer.total <= 1) return null

  return (
    <div className="flex">
      <div
        className={styles.base()}
        onClick={() => {
          if (hovering) {
            props.timer.goNext
          }
        }}
        onMouseEnter={() => {
          setHovering(true)
          props.timer.pause()
        }}
        onMouseLeave={() => {
          setHovering(false)
          props.timer.start()
        }}
      >
        {Array.from({ length: props.timer.total }, (_, index) => {
          const active = index === props.timer.current
          return (
            <div
              data-part="indicator"
              key={index}
              className={styles.indicator({ active })}
              onClick={(e) => {
                if (hovering) {
                  props.timer.goTo(index)
                  trackEvent("Go To Slide", {}, e.currentTarget)
                }
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

const createStyles = tv({
  base: "flex flex-none gap-[4px] relative before:content-space before:absolute before:-inset-3 cursor-pointer",
  slots: {
    indicator: [
      "w-[4px] h-[4px] rounded-full bg-fg opacity-30 relative transition-all duration-700",
      "after:content-space after:absolute after:-inset-x-[1px] after:-inset-y-[4px]",
    ],
  },
  variants: {
    active: {
      true: {
        indicator: "w-[16px] !opacity-100",
      },
    },
    hovering: {
      true: {
        indicator: "w-[16px] h-[8px] transition-all duration-300 hover:opacity-60",
      },
    },
  },
  compoundVariants: [
    {
      hovering: true,
      active: true,
      css: {
        indicator: "w-[24px]",
      },
    },
  ],
})
